import useMutationHallDelete from "./hall-use-mutation-delete";
import useMutationHallUploadFile from "./hall-use-mutation-upload-file";


export const hallUseMutation = {
  delete: useMutationHallDelete,
  uploadFile: useMutationHallUploadFile,
}